module.exports = __webpack_public_path__ + "static/celebrity-report-card-image-3bdf36b6d2735789cd192433668416dc.jpg";